module.exports = __webpack_public_path__ + "static/media/JillyJonka.6b733cb7.png";